import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type SessionService from 'garaje/services/session';

import type LoginController from './controller';
import type { RedirectCode } from './controller';

const SAML_CONFIRM_EMAIL_REDIRECT_CODE = 114;

export default class LoginRoute extends Route {
  @service declare session: SessionService;
  @service declare router: RouterService;

  title = 'Log in to Envoy';

  beforeModel(): void {
    this.session.prohibitAuthentication('protected');
  }

  setupController(controller: LoginController, model: unknown, transition: Transition): void {
    super.setupController(controller, model, transition);

    const { rc: redirectCode } = controller;
    if (redirectCode) {
      if (Number(redirectCode) === SAML_CONFIRM_EMAIL_REDIRECT_CODE) {
        this.router.transitionTo('sso-confirm-email');
        return;
      }
      controller.showRedirectCodeError(<RedirectCode>(<unknown>redirectCode));
    }
  }
}
